import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Navigate, useRoutes} from "react-router-dom";
import RequireAuthorized from "./components/require-auth.component";
import RequireUnauthorized from "./components/require-unauthorized.component";
import RouterSuspense from "./components/router-suspense.component";
import {GlobalStoreContextProvider} from "./context";
import {GlobalStore} from "./stores";
import {ToastContainer} from "react-toastify";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PublicOfferPage from "./pages/PublicOfferPage";

const AuthorizedArea = React.lazy(async () => import("./areas/authorized-area.component"));
const UnauthorizedArea = React.lazy(async () => import("./areas/unauthorized-area.component"));
const LoginPage = React.lazy(async () => import("./pages/LoginPage"));
const MainPage = React.lazy(async () => import("./pages/MainPage"));
const EventsPage = React.lazy(async () => import("./pages/EventsPage"));
const LocationsPage = React.lazy(async () => import("./pages/LocationsPage"));
const BrandsPage = React.lazy(async () => import("./pages/BrandsPage"));
const PurchasesPage = React.lazy(async () => import("./pages/PurchasesPage"));
const UsersPage = React.lazy(async () => import("./pages/UsersPage"));
const TicketsPage = React.lazy(async () => import("./pages/TicketsPage"));
const BraceletsPage = React.lazy(async () => import("./pages/BraceletsPage"));
const AddTicketsPage = React.lazy(async () => import("./pages/AddTicketPage"));
const AddBrandPage = React.lazy(async () => import("./pages/AddBrandPage"));
const AddEventPage = React.lazy(async () => import("./pages/AddEventPage"));
const AddLocationPage = React.lazy(async () => import("./pages/AddLocationPage"));
const SettingPage = React.lazy(async () => import("./pages/SettingPage"));

const TicketEventPage = React.lazy(async () => import("./pages/TicketEventPage"));



const Root = () => {
    const routes = useRoutes([
        {
            path: '/',
            element: <RequireAuthorized> <AuthorizedArea /> </RequireAuthorized >,
            children: [
                { path: 'purchases', element: <PurchasesPage /> },
                { path: 'users', element: <UsersPage /> },
                { path: 'tickets', element: <TicketsPage /> },
                { path: 'bracelets', element: <BraceletsPage /> },
                { path: 'events', element: <EventsPage /> },
                { path: 'locations', element: <LocationsPage /> },
                { path: 'brands', element: <BrandsPage /> },
                { path: 'add-ticket', element: <AddTicketsPage /> },
                { path: 'add-brand', element: <AddBrandPage /> },
                { path: 'add-event', element: <AddEventPage /> },
                { path: 'add-location', element: <AddLocationPage /> },
                { path: 'settings', element: <SettingPage /> },

            ]
        },
        {
            element: <RequireUnauthorized> <UnauthorizedArea /> </RequireUnauthorized >,
            children: [
                { path: 'login', element: <LoginPage /> },

            ]
        },
        {
            children: [
                {path: 'public-offer', element: <PublicOfferPage/>},
                {path: 'ticket-event/:id', element: <TicketEventPage />}
            ]

        },


    ]);
    return (
        <Suspense fallback={<RouterSuspense />}>
            <HelmetProvider>
                <Helmet>
                    <title>Attractions</title>
                </Helmet>
                {routes}
            </HelmetProvider>
        </Suspense>
    );
}



ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <GlobalStoreContextProvider value={GlobalStore}>
            <BrowserRouter>
                <ToastContainer />
                <Root />
            </BrowserRouter>
        </GlobalStoreContextProvider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
